<!-- 富文本内容 -->
<template>
  <div
    class='rich_text_wrap'
    v-html="info"
  ></div>
</template>

<script>
export default {
  name: 'RichText',
  props: {
    info: {
      String,
      default: ''
    }
  },
  data() {
    return {

    };
  },

  watch: {
    info(val) {
      if (val) {
        this.setAttribute()
        this.resetAclick()
      }
    }
  },

  components: {},

  methods: {
    // 获取图片列表
    setAttribute() {
      this.$nextTick(() => {
        let imgs = document.getElementsByTagName('img')
        imgs.forEach(img => {
          if (!img.className) {
            let imgParent = img.parentNode
            imgParent.style.fontSize = 0
          }
        });
      })
    },
    // 重置a标签点击事件
    resetAclick() {
      this.$nextTick(() => {
        let eles = document.getElementsByTagName('a')
        eles.forEach(ele => {
          if (ele.href) {
            ele.onclick = () => {
              window.location.href = ele.href
            }
          }
        })
      })
    },
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.rich_text_wrap {
  width: 100%;
  font-size: 14px;
  /deep/p {
    line-height: 1.2;
  }
  /deep/span {
    width: 100%;
    display: inline-block;
  }
  /deep/img {
    width: 100%;
  }
  /deep/strong,
  b {
    font-weight: bold;
  }
  /deep/em,
  /deep/i {
    font-style: italic;
  }
  /deep/hr {
    display: block !important;
    unicode-bidi: isolate !important;
    margin-block-start: 0.5em !important;
    margin-block-end: 0.5em !important;
    margin-inline-start: auto !important;
    margin-inline-end: auto !important;
    overflow: hidden !important;
    border-style: inset !important;
    border-width: 1px !important;
  }
  /deep/h1 {
    margin: 0.67em 0 !important;
    font-size: 2em !important;
    font-weight: bold !important;
  }
  /deep/h2 {
    margin: 0.83em 0 !important;
    font-size: 1.5em !important;
    font-weight: bold !important;
  }
  /deep/h3 {
    margin: 1.17em 0 !important;
    font-size: 1.17em !important;
    font-weight: bold !important;
  }
  /deep/h4 {
    // font-size: 12px !important;
    margin: 1.33em 0 !important;
    font-weight: bold !important;
  }
  /deep/h5 {
    margin: 1.67em 0 !important;
    font-size: 0.83em !important;
    font-weight: bold !important;
  }
  /deep/.ql-align-center {
    text-align: center;
  }
  /deep/.ql-align-right {
    text-align: right;
  }
  /deep/.ql-align-justify {
    text-align: justify;
  }
  /deep/ ol {
    list-style: revert !important;
    margin: 10px 0 10px 20px;
    li {
      &::marker {
        unicode-bidi: isolate;
        font-variant-numeric: tabular-nums;
        text-transform: none;
        text-indent: 0px !important;
        text-align: start !important;
        text-align-last: start !important;
      }
    }
  }
  /deep/ ul {
    list-style: revert !important;
    margin: 10px 0 10px 20px;
    li {
      &::marker {
        unicode-bidi: isolate;
        font-variant-numeric: tabular-nums;
        text-transform: none;
        text-indent: 0px !important;
        text-align: start !important;
        text-align-last: start !important;
      }
    }
  }
}
</style>